module.exports = __webpack_public_path__ + "img/plus-active.318db276.svg";